const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP", // You can change 'USD' to your desired currency code
      // Other options like minimumFractionDigits can be added for more control
    }).format(amount);
  };

  export default formatCurrency;